import { cx } from '@vizit/theme';
import { Text, type TextProps, TextSize } from '../text';

interface AlertDescriptionProps extends TextProps {
  size?: TextSize;
}

function AlertDescription(props: AlertDescriptionProps) {
  const { children, className, size = TextSize.Sm, ...other } = props;

  return (
    <Text className={cx('text-tertiary whitespace-pre-wrap', className)} size={size} {...other}>
      {children}
    </Text>
  );
}

export { AlertDescription };
